import { render, staticRenderFns } from "./farm-movie.vue?vue&type=template&id=5a2b679e&"
import script from "./farm-movie.vue?vue&type=script&lang=js&"
export * from "./farm-movie.vue?vue&type=script&lang=js&"
import style0 from "./farm-movie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports